import React, {Component} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames';
import querystring from 'query-string'

import TeamBlogHeadFilterPanel from './TeamBlogHeadFilterPanel';
import { parseListParams } from './TeamblogListHelper';
import ItemAllCheckbox from '../../common/EntryItemAllCheckbox';
import { jsonResponseHandler } from '../../../utils/FetchHelper'

import { selectAllItems, deselectAllItems, updateSelectedItems, receiveItems} from '../../../actions/setting/teamblog';
import { updateUserRole } from '../../../actions/user';
import WindowEventHelper from "../../../lib/WindowEventHelper";

@connect(state => ({
    items: state.teamblog.item.items,
    searchKeyword: state.teamblog.condition.searchKeyword,
    currentUserId : state.user.userId,
    currentUserRole : state.user.role,
}), dispatch => ({
    handleSelectAllItems: () => {
        dispatch(selectAllItems())
    },
    handleDeselectAllItems: () => {
        dispatch(deselectAllItems())
    },
    handleUpdateSelectedItems: (values) => {
        dispatch(updateSelectedItems(values))
    },
    handleReceiveTeamBlogs: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    handleUpdateCurrentRole: (role) => {
        dispatch(updateUserRole(role))
    },
    dispatch
}))
class TeamBlogListHeader extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            optionOpen: false,
            searchOpen: false,
            processing: false,
            searching: false,
            searchKeyword : '',
        };

        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleToggleOption = this.handleToggleOption.bind(this);
        this.handleHideOption = this.handleHideOption.bind(this);
        this.handleOpenSearch = this.handleOpenSearch.bind(this);
        this.handleCloseSearch = this.handleCloseSearch.bind(this);
        this.handleCloseSearchWithKey = this.handleCloseSearchWithKey.bind(this);
        this.updateItems = this.updateItems.bind(this);
        this.handleChangingToManager = this.handleChangingToManager.bind(this);
        this.handleChangingToEditor = this.handleChangingToEditor.bind(this);
        this.handleChangingToWriter = this.handleChangingToWriter.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.renderChangeRoleActionPanel= this.renderChangeRoleActionPanel.bind(this);
        this.callDeleteMember= this.callDeleteMember.bind(this);
    }

    componentDidMount() {
		WindowEventHelper.add("click", this.handleHideOption)
		WindowEventHelper.add("keydown", this.handleCloseSearchWithKey)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleHideOption)
		WindowEventHelper.remove("keydown", this.handleCloseSearchWithKey)
    }

    componentWillReceiveProps(nextProps) {
        const { searchKeyword } = this.state;
        const nextSearchKeyword = nextProps.searchKeyword;
        if(nextSearchKeyword === '' || searchKeyword === nextSearchKeyword){
            this.setState({
                searching: false,
            });
        }
    }

    handleSelectAll(e) {
        const { handleSelectAllItems, handleDeselectAllItems } = this.props
        if (e.target.checked) {
            handleSelectAllItems()
        } else {
            handleDeselectAllItems()
        }
    }

    handleToggleOption(e) {
        const { optionOpen } = this.state;

        this.setState({
            optionOpen: !optionOpen
        })
    }

    handleHideOption(e) {
        const { btnOptionOpen } = this.refs;
        if (e.target !== btnOptionOpen
            && e.target.parentNode
            && e.target.parentNode !== btnOptionOpen
            && e.target.parentNode.className !== "list_opt"
            && e.target.parentNode.parentNode
            && e.target.parentNode.parentNode.className !== "list_opt") {
            this.setState({
                optionOpen: false
            })
        }
    }

    handleOpenSearch(e) {
        const { searchText } = this.refs;
        searchText.value='';
        this.setState({
            searchOpen: true,
            searchKeyword:''
        });
        setTimeout(() => { searchText.focus() }, 100)

    }

    handleCloseSearch(e) {
        this.setState({
            searchOpen: false
        })
    }

    handleCloseSearchWithKey(e) {

        if (this.state.searchOpen) {
            if(e.keyCode === 27) {
                this.handleCloseSearch()
            }else if(e.keyCode === 13) {
                this.handleSearch();
                this.handleCloseSearch();
            }
        }
    }

    handleSearch() {
        const searchKeyword = this.state.searchKeyword;

        let history = this.props.history;
        let location = this.props.location;

        if (searchKeyword.length > 0) {

            let listParams = parseListParams(location.search);
            if(listParams.searchKeyword !== searchKeyword){
                history.push(location.pathname + "?" + querystring.stringify({searchKeyword: searchKeyword}));
                this.setState({
                    searching: true,
                });
            }
        }
        this.handleCloseSearch();
    }

    updateItems(changes) {
        const { items, handleUpdateSelectedItems, currentUserId, handleUpdateCurrentRole, dispatch } = this.props;
        let ids = items.filter(item => item.selected).map(item => item.userId);
        let selfExist = (items.filter(item => item.selected).findIndex(item => item.userId === currentUserId) !== -1);
        handleUpdateSelectedItems({ processing : true});
        fetch("/manage/teamblog/role.json", {
            method: "put",
            credentials: "include",
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: querystring.stringify(
                Object.assign({}, { ids: ids.join(",") }, changes)
            )
        })
            .then(jsonResponseHandler(dispatch))
            .then(data => {
                changes.processing = false;
                handleUpdateSelectedItems(changes);
                this.setState({
                    optionOpen: false,
                    processing : false
                });
                if(selfExist) {
                    handleUpdateCurrentRole(changes.role);
                }
            })
            .catch(r => {
                this.setState({
                    optionOpen: false,
                    processing : false
                });
                handleUpdateSelectedItems({ processing : false});
                console.error(r)
            })
    }

    handleChangingToManager(e) {
        this.updateItems({role: 'manager'});
    }

    handleChangingToEditor(e) {
        this.updateItems({role: 'editor'});
    }

    handleChangingToWriter(e) {
        this.updateItems({role: 'writer'});
    }

    handleDelete(e) {

        const { items, currentUserId, currentUserRole } = this.props;

        let ids = items.filter(item => item.selected).map(item => item.userId);
        let selfExist = (items.filter(item => item.selected).findIndex(item => item.userId === currentUserId) !== -1);

        if(currentUserRole === 'owner' || currentUserRole === 'manager') {
            if (confirm('선택한 멤버를 팀블로그에서 탈퇴 처리하시겠습니까?')) {

                if(selfExist) {
                    if(confirm('자기 자신이 포함되어 있습니다. 계속 진행하시겠습니까?')) {
                        this.callDeleteMember(ids);
                    }
                }else{
                    this.callDeleteMember(ids);
                }
            }
        }else{
            if(confirm('팀블로그에서 탈퇴하시겠습니까?')){
                if(selfExist && ids.length === 1){
                    this.callDeleteMember(ids);
                }
            }
        }
    }

    callDeleteMember(ids) {

        const { currentUserId, dispatch } = this.props;
        let selfExist = (ids.findIndex(id => id === currentUserId) !== -1);

        this.setState({
            processing: true
        });

        fetch("/manage/teamblog/members.json", {
            method: "delete",
            credentials: "include",
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: querystring.stringify({
                ids: ids.join(",")
            })
        })
            .then(jsonResponseHandler(dispatch))
            .then(data => {
                if(selfExist) {
                    window.location = '/';
                }else{
                    this.reFetchTeamBlogs();
                    this.setState({
                        optionOpen: false
                    })
                }

            })
            .catch(e => {
                console.log(e);
                this.setState({
                    processing: false,
                    optionOpen: false
                });
            })
    }

    reFetchTeamBlogs() {

        const { dispatch } = this.props;

        fetch("/manage/teamblog/members.json" + location.search, {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveTeamBlogs(data.items, data.totalCount);
                this.setState({
                    processing:false,
                    optionOpen: false
                });
            })
            .catch(e => {
                console.log(e);
                this.setState({
                    processing:false,
                    optionOpen: false
                });
            })
    }

    searchUpdated (event) {
        const keyword = event.target.value;
        this.setState({searchKeyword: keyword})
    }

    render() {

        const { optionOpen, searchOpen, searchKeyword, processing, searching } = this.state;
        const { items } = this.props;

        let selectedCount = items.filter(item => item.selected).length;

        let optionAvailable = selectedCount > 0;
        let searchable = searchKeyword.length > 0;

        if(searching) {
            return (<div className="wrap_search loading_search">
                <em className="txt_keyword">{searchKeyword}</em>
                <span className="txt_change">
                        검색중
                        <span className="ico_blog ico_change"/>
                    </span>
            </div>);
        }

        return (<div className={classnames({
            "wrap_search": true,
            "on": searchOpen
        })}>
            <ItemAllCheckbox items={items} handleSelectAll={this.handleSelectAll}/>
            <div className="search_blog">
                <input type="text" ref="searchText" className="tf_search" title="검색어 입력" placeholder="팀블로그 관리에서 검색합니다." onChange={(e) => this.searchUpdated(e)} />
                    <div className="info_search">
                        <button type="button" className="btn_search" onClick={this.handleOpenSearch}>
                            검색
                            <span className="ico_blog ico_search"> 열기</span>
                        </button>
                        <button type="button" className="btn_search btn_query" disabled={!searchable} onClick={this.handleSearch}>
                            <span className="ico_blog ico_search">검색 하기</span>
                        </button>
                        <button type="reset" className="btn_del" onClick={this.handleCloseSearch}>닫기</button>
                    </div>
            </div>
            <div className={classnames({
                "opt_blog": true,
                "opt_open": optionOpen,
                "change_on" : processing
            })}>
                <button ref="btnOptionOpen" type="button" className="btn_opt" disabled={!optionAvailable} onClick={this.handleToggleOption}>
                    변경
                    <span className="ico_blog ico_open" />
                </button>
                <span className="txt_change">
                    변경중
                    <span className="ico_blog ico_change"/>
                </span>
                <div className="layer_opt layer_member">
                    {this.renderChangeRoleActionPanel()}
                    <div className="opt_etc">
                        <label className="lab_btn">
                            탈퇴
                            <input type="button" className="btn_g" value="탈퇴" onClick={this.handleDelete}/>
                        </label>
                    </div>
                </div>
            </div>
            <TeamBlogHeadFilterPanel />
        </div>);

    }

    renderChangeRoleActionPanel() {

        const { currentUserRole } = this.props;
        let markUp = [];
        if(currentUserRole === 'owner' || currentUserRole === 'manager') {
            markUp.push(<strong className="tit_opt">권한 변경</strong>);
            markUp.push(<ul className="list_opt">
                <li>
                    <label className="lab_btn">
                        관리자
                        <input type="button" className="btn_g" value="관리자" onClick={this.handleChangingToManager}/>
                    </label>
                </li>
                <li>
                    <label className="lab_btn">
                        편집자
                        <input type="button" className="btn_g" value="편집자" onClick={this.handleChangingToEditor}/>
                    </label>
                </li>
                <li>
                    <label className="lab_btn">
                        필자
                        <input type="button" className="btn_g" value="필자" onClick={this.handleChangingToWriter}/>
                    </label>
                </li>
            </ul>);
        }
        return markUp;
    }
}

export default TeamBlogListHeader;
